var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgVector = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 120,
  height: 189,
  fill: "none",
  viewBox: "0 0 120 189"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#A0DCF1",
  d: "M0 44.89V8a8 8 0 0 1 8-8h104c4.418 0 8.011 3.658 6.521 7.817-2.693 7.516-9.898 17.931-28.004 28.123C67.99 48.62 28.934 51.972 8.095 52.783 3.637 52.956 0 49.35 0 44.89"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 60,
  cy: 129,
  r: 60,
  fill: "#FFCD55"
})));
export { SvgVector as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjE4OSIgdmlld0JveD0iMCAwIDEyMCAxODkiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0wIDQ0Ljg5MDRWOEMwIDMuNTgxNzIgMy41ODE3MiAwIDggMEgxMTJDMTE2LjQxOCAwIDEyMC4wMTEgMy42NTc5MSAxMTguNTIxIDcuODE3MjZDMTE1LjgyOCAxNS4zMzMgMTA4LjYyMyAyNS43NDggOTAuNTE3MiAzNS45Mzk5QzY3Ljk4OTkgNDguNjIwNyAyOC45MzQzIDUxLjk3MTUgOC4wOTQ4MiA1Mi43ODI2QzMuNjM3MzcgNTIuOTU2MSAwIDQ5LjM1MTMgMCA0NC44OTA0WiIgZmlsbD0iI0EwRENGMSIvPgo8Y2lyY2xlIGN4PSI2MCIgY3k9IjEyOSIgcj0iNjAiIGZpbGw9IiNGRkNENTUiLz4KPC9zdmc+Cg==";